module.exports = __webpack_public_path__ + "static/happiness-guarantee-ed5cb59d193bea2998235462feb79864.svg";